<template>
  <detail-layout>
    <template slot="header">
      <base-header icon="user" :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form :model="form" :rules="updateRules" ref="ruleForm" class="flex flex-row w-full">
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">

              <div class="w-full" v-if="form.Distribuidor">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.entity_name')}}</label>
                <el-form-item prop="Distribuidor">
                    <el-input
                      disabled
                      class="w-full"
                      v-model="form.Distribuidor"
                    />
                  </el-form-item>
              </div>

              <div class="w-full" v-if="!form.rol || (form.rol !== 8 && form.rol !== 7 && form.rol !== 3)">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
                <el-form-item prop="company">
                    <el-input
                      disabled
                      class="w-full"
                      v-model="form.company"
                    />
                  </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1"><base-obligatory-icon/>{{ $t('users.entity_name') }}</label>
                <el-form-item prop="name">
                  <el-input clearable class="w-full" v-model="form.name" />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $tc('users.email', 1) }}</label>
                <el-form-item prop="email">
                  <el-input clearable class="w-full" v-model="form.email" maxlength="255" />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $tc('app.role', 1) }}</label>
              <el-form-item prop="rol">
                <el-input class="w-full" v-model="profileRoleLabel" disabled />
              </el-form-item>
            </div>
            <div v-if="(hasAADIntegration || hasSAML2Integration) && !isRoleProvider" class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('users.tipo_auth') }}</label>
              <el-form-item prop="tipoAuth">
                <base-el-select class="w-full" :options="tiposAuthFiltered" v-model="form.tipoAuth" clearable :disabled="form.rol === 3" />
              </el-form-item>
            </div>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.language') }}</label>
              <el-form-item prop="idioma">
                <base-el-select class="w-full" :options="tiposIdioma" v-model="form.idioma" :option-label="langOptionLabel" />
              </el-form-item>
            </div>
            <div 
              v-if="!(form.rol === 7 || isRoleProvider)"
              class="lg:mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch name="testswitch" class="switch-text break-normal"
                    :disabled="isRoleProvider || form.rol === 1 || form.rol === 4 || form.rol === 7 || form.rol === 8 || form.rol === 3"
                    v-model="form.verTodoStatuses" :active-text="$t('configurations.ver_todo_statuses')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1" />
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch name="testswitch" class="switch-text break-normal"
                    :disabled="isRoleProvider || form.rol === 1 || form.rol === 4 || form.rol === 7 || form.rol === 8 || form.rol === 3"
                    v-model="form.verTodoCompanies" :active-text="$t('configurations.ver_todo_companies')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1" />
                </div>
              </div>
            </div>

            <div v-if="form.rol !== 7 && form.rol !== 8 && form.rol !== 3 
              && form.Grupos && form.Grupos.length > 0">
              <div class="mb-4 w-full border-b border-solid border-gray-100 dark:border-darkblue-600"/>

              <div class="mt-4 mb-4">
                <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{$t('groups.my_groups')}}</h3>
                <el-table
                  ref="grupos"
                  :data="form.Grupos"
                  style="width: 100%"
                  max-height="240"
                  :show-header="form.Grupos && form.Grupos.length > 0">
                  <el-table-column
                    prop="Nombre"
                    :label="$t('app.name')"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="Tipo"
                    :label="$t('app.type')"
                    :width="groupTypeWidth"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="Temporal"
                    label=""
                    width="110"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.Temporal" class="rounded-full mr-1 mb-1 pl-1 pr-1 bg-primary-50 dark:bg-darkblue text-primary border-2 tag-cell">
                        {{$tc('groups.temporal', 1)}}
                      </span>
                      <!-- <el-tag v-if="scope.row.Temporal" size="medium">Temporal</el-tag> -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div class="mb-2 lg:mb-6 w-full border-b border-solid border-gray-100 dark:border-darkblue-600" />

            <!-- <div v-if="(role === 7 || role === 8 || role === 3)" class="mb-4 lg:mb-6 flex flex-row items-center">
              <el-switch @change="onChangeDashboardEnable()" name="testswitch" class="switch-text break-normal" v-model="unableDashboardValue" :active-text="$t('configurations.dashboard_unabled')"></el-switch>
            </div> -->
            <div class="mb-4 lg:mb-6 flex flex-row items-center">
              <el-switch @change="onChangeAutoIdleTime()" name="testswitch" class="switch-text break-normal" v-model="autoIdleTimeValue" :active-text="$t('configurations.auto_idle_time')"></el-switch>
            </div>
            <div class="lg:mb-4">
              <div class="flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0 mt-2"
                  v-if="form.tipoAuth === 'Mixto' || form.tipoAuth === 'Local' || form.tipoAuth === 0 || form.tipoAuth === 2">
                  <base-button-responsive mode="primary" :text="$t('configurations.change_password')" icon="lock"
                    @click="generatePassword" :loading="isGeneralLoading" />
                </div>
                <div class="px-2 w-full mb-2 lg:mb-0 mt-2 flex flex-row items-center">
                  <base-button-responsive mode="primary" :text="$t('configurations.reset_views')" icon="retry"
                    @click="resetViews" :loading="isGeneralLoading" />
                  <base-tooltip-icon size="md" :content="tooltipResetViews" class="ml-4" />
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
            :loading="isGeneralLoading" />
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
            :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        </template>
      </base-footer>
      <user-generate-password-dialog :dialogOpen="showGeneratePassword" :email="localUser.IdUsuario"
        @toggleDialog="toggleDialogs" />

    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { setUserData } from '@/services/configurations/setUserData'
import { resetVistas } from '@/services/grids/resetVistas'
import { i18n } from '@/i18n'
import UserGeneratePasswordDialog from '@/components/UserGeneratePasswordDialog.vue'
import { email } from '@/utils/regex'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayout,
    UserGeneratePasswordDialog
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUser: null,
      reg: email,
      autoIdleTimeValue: false,
      unableDashboardValue: false,
      form: this.getDefaultForm(),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      updateRules: {
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        tipoAuth: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        idioma: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
      }
    }
  },
  computed: {
    header: function () {
      return {
        title: i18n.t('app.user_profile_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: null
      }
    },
    tooltipVerTodoStatuses: function () {
      return i18n.t('tooltip.ver_todo_statuses')
    },
    tooltipVerTodoCompanies: function () {
      return i18n.t('tooltip.ver_todo_companies')
    },
    tooltipResetViews: function () {
      return i18n.t('tooltip.reset_views')
    },
    isRoleProvider: function () {
      return this.role === 9
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    roles: function () {
      return this.$store.getters['config/ROLES']
    },
    profileRoleLabel: function () {
      const role = this.roles.find(x => x.id === this.form.rolId)
      return role?.name ?? this.form.rol
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    lastRoute: function () {
      return this.$store.getters['app/fromRoute']
    },
    hasAADIntegration: function () {
      return !!this.$store.getters['auth/hasIntegracionAADModule']
    },
    hasSAML2Integration: function () {
      return !!this.$store.getters['auth/hasSAML2Module']
    },
    groupTypeWidth: function () {
      if (i18n.locale === 'de') {
        return 160
      }
      return 120
    },
    tiposAuthFiltered: function () {
      var arrayAuthTypes = this.$store.getters['config/TIPOS_AUTH']
      if (!this.hasAADIntegration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['AAD', 'Mixto'].includes(x.key))
      }
      if (!this.hasSAML2Integration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['SAML2', 'MixtoSAML2'].includes(x.key))
      }
      return arrayAuthTypes
    },
    tiposIdioma: function () {
      return this.$store.getters['config/TIPOS_IDIOMA']
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
  },
  created: async function () {
    const localUser = this.$store.getters['auth/user']
    this.localUser = localUser
    this.setUser(localUser)

    // const breadcrumbs = []
    // breadcrumbs.push({
    //   path: 'configurations',
    //   name: i18n.t('configurations.header')
    // })
    // breadcrumbs.push({
    //   path: 'configurations/users',
    //   name: i18n.t('users.header')
    // })
    // breadcrumbs.push({ path: '', name: this.form.name })
    // this.header.breadcrumb = breadcrumbs
  },
  methods: {
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        company: '',
        Distribuidor: '',
        active: false,
        created_at: '',
        password: '',
        repeat_password: '',
        rol: '',
        rolId: '',
        verTodoStatuses: false,
        verTodoCompanies: false,
        tipoAuth: 0,
        Grupos: [],
        idioma: '',
      }
    },
    langOptionLabel: function (option) {
      return option.localName
    },
    onChangeAutoIdleTime () {
      this.$store.dispatch('app/updateautoIdleTime', this.autoIdleTimeValue)
      this.doFeedback(i18n.tc('feedback.success.close_sesion_config_msg', this.autoIdleTimeValue ? process.env.VUE_APP_IDLE_TIME : 0), 'success')
    },
    onChangeDashboardEnable () {
      this.$store.dispatch('dashboard/setUnableDashboard', this.unableDashboardValue)
      this.doFeedback(i18n.tc('feedback.success.load_dashboard_config_msg', Number(this.unableDashboardValue)), 'success')
    },
    watchFormHandler: function ({ certificate, send_alerts }) { },
    toggleDialogs: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      if (!this.reg.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    submitForm: function (formName) {
      if (this.$route.params.id !== -1) {
        this.updateUserHandler(formName)
      }
    },
    updateUserHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            Email: this.form.email,
            Nombre: this.form.name,
            Idioma: this.form.idioma
          }
          if (this.form.rol !== 1 && this.form.rol !== 4) {
            params.VerTodoEstados = this.form.verTodoStatuses
            params.VerTodoEmpresas = this.form.verTodoCompanies
            if (this.form.rol === 3 && (this.hasAADIntegration || this.hasSAML2Integration)) {
              params.idTipoAutenticacion = this.form.tipoAuth
            }
          }
          const response = await setUserData(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.$store.commit('auth/setLocale', params.Idioma)
            this.$nextTick(() => this.reloadGrupos(this.form.Grupos))
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetViews: async function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const response = await resetVistas()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          // Reset all stores
          this.$store.dispatch('invoicesIssued/resetCartState')
          this.$store.dispatch('invoicesReceived/resetCartState')
          this.$store.dispatch('historicalUser/resetCartState')
          this.$store.dispatch('historicalGroup/resetCartState')
          this.$store.dispatch('historicalClient/resetCartState')
          this.$store.dispatch('historicalCert/resetCartState')
          this.$store.dispatch('historicalCompany/resetCartState')
          this.$store.dispatch('historicalInvoice/resetCartState')
          this.$store.dispatch('companies/resetCartState')

          this.$store.dispatch('certificates/resetCartState')
          this.$store.dispatch('certcompanies/resetCartState')
          this.$store.dispatch('clients/resetCartState')
          this.$store.dispatch('imports/resetCartState')
          this.$store.dispatch('users/resetCartState')
          this.$store.dispatch('userscompanies/resetCartState')
          this.$store.dispatch('userstatus/resetCartState')

          this.$store.dispatch('groups/resetCartState')
          this.$store.dispatch('groupusers/resetCartState')
          this.$store.dispatch('groupcompanies/resetCartState')
          this.$store.dispatch('groupstatus/resetCartState')
          this.$store.dispatch('invoicegroups/resetCartState')
          this.$store.dispatch('usergroups/resetCartState')
          this.$store.dispatch('trashGroups/resetCartState')
          this.$store.dispatch('trashHistoricalGroups/resetCartState')

          // Sociedades
          this.$store.dispatch('sociedades/resetCartState')
          this.$store.dispatch('trashSociedades/resetCartState')
          this.$store.dispatch('historicalContact/resetCartState')
          this.$store.dispatch('trashHistoricalContacts/resetCartState')
          this.$store.dispatch('sedes/resetCartState')
          this.$store.dispatch('administrativecenters/resetCartState')
          this.$store.dispatch('administrativecentersfb2b/resetCartState')

          this.$store.dispatch('impuestos/resetCartState')
          this.$store.dispatch('trashImpuestos/resetCartState')
          this.$store.dispatch('historicalImpuestos/resetCartState')
          this.$store.dispatch('trashHistoricalImpuestos/resetCartState')

          this.$store.dispatch('products/resetCartState')
          this.$store.dispatch('productsImpuestos/resetCartState')
          this.$store.dispatch('trashProducts/resetCartState')
          this.$store.dispatch('historicalProducts/resetCartState')
          this.$store.dispatch('trashHistoricalProducts/resetCartState')

          // Distribuidor
          this.$store.dispatch('distributors/resetCartState')
          // this.$store.dispatch('distributorlocations/resetCartState')
          this.$store.dispatch('historicalDistributor/resetCartState')

          // Agrupaciones
          this.$store.dispatch('groupingcompanies/resetCartState')
          this.$store.dispatch('groupingbuyers/resetCartState')
          this.$store.dispatch('groupingsellers/resetCartState')


          // Papelera
          this.$store.dispatch('trashUsers/resetCartState')
          this.$store.dispatch('trashHistoricalUsers/resetCartState')
          this.$store.dispatch('trashInvoicesIssued/resetCartState')
          this.$store.dispatch('trashInvoicesReceived/resetCartState')
          this.$store.dispatch('trashHistoricalInvoices/resetCartState')
          this.$store.dispatch('trashCertificates/resetCartState')
          this.$store.dispatch('trashHistoricalCertificates/resetCartState')
          this.$store.dispatch('trashCompanies/resetCartState')
          this.$store.dispatch('trashHistoricalCompanies/resetCartState')

          this.doFeedback(i18n.t('feedback.success.reset_views_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goBack: function () {
      this.$router.push(this.lastRoute)
    },
    setUser: function (user) {
      this.form.id = user.idUsuario
      this.form.name = user.Usuario
      this.form.email = user.Email
      this.form.company = user.Cliente
      this.form.Distribuidor = user.Distribuidor
      this.form.active = user.active
      this.form.created_at = user.created_at
      this.form.rolId = user.idRol
      this.form.rol = user.Rol
      this.form.verTodoStatuses = user.VerTodoEstados
      this.form.verTodoCompanies = user.VerTodoEmpresas
      const tipoAuth = this.tiposAuthFiltered.find(x => x.id === user.idTipoAutenticacion)
      this.form.tipoAuth = tipoAuth?.id ?? user.idTipoAutenticacion
      this.autoIdleTimeValue = this.$store.getters['app/autoIdleTime']
      this.unableDashboardValue = this.$store.getters['dashboard/getUnableDashboard']
      this.form.idioma = user.LangCode
      this.reloadGrupos(user.Grupos)
    },
    generatePassword: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    reloadGrupos: function (grupos) {
      const groups = []
      if (grupos) {
        grupos.forEach(grupo => {
          const group = grupo
          const tipoGrupo = this.tiposGrupo.find(x => x.id === grupo.idTipo)
          if (tipoGrupo) {
            group.Tipo = tipoGrupo.name
          } else {
            console.warn(i18n.t('feedback.warning.unrecognized_group_type_warn', { groupType: grupo.idTipo }))        
            group.Tipo = grupo.idTipo
          }
          groups.push(group)
        })
      }
      this.form.Grupos = groups
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}

.grid {
  display: grid;
  grid-gap: 10px;
}

.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}

.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}

.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}

.tip {
  grid-column: 1 / -1;
}

.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style scoped>
.tag-cell {
  border-color: var(--Tag-border-)!important;
}
</style>
